import React, { Component } from "react";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";
import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";

// CSS
import "../../css/product-prices.css";

// Utils
import { setProductFinalPrice } from "../../store/actions/product";
import { calculateSalePrice, getFirstVariants } from "../../utils/salePrices.js";

class ProductPriceList extends Component {
	constructor(props) {
		super(props);
		this.state = {
			pricesObj: {},
			priceClassName: "price",
			productTotal: this.props.product.price,
			topTierOriginalPrice: 0
		};
	}

	componentDidMount() {
		this.determinePrices(this.props.variantItem, this.props.siteInfo);
	}

	componentWillReceiveProps(nextProps) {
		// Determine prices if there is a new variant for the product, or if the siteInfo has finally loaded
		if ((!isEqual(this.props.variantItem, nextProps.variantItem) && nextProps.siteInfo.isLoading === 0) || this.props.siteInfo.isLoading !== nextProps.siteInfo.isLoading) {
			this.determinePrices(nextProps.variantItem, nextProps.siteInfo);
		}
	}

	determinePrices(variantItemToUse, siteInfo) {
		const prices_shown = !!siteInfo.prices_shown ? siteInfo.prices_shown : 0;
		const { product } = this.props;
		let productTotal = product.price;

		// Only do this stuff if we need to actually show prices
		if (prices_shown) {
			let { prices = {}, promotions = {} } = product;

			// Get top tier price if exists
			if(!!product.top_tier_original_price){
				this.setState({
					topTierOriginalPrice: product.top_tier_original_price
				})
			}

			// Set class for element
			if (!isEmpty(prices) || !isEmpty(promotions)) {
				this.setState({
					priceClassName: this.state.priceClassName + " inactive"
				});
			}

			// Sale prices
			this.setState({
				pricesObj: Object.keys(prices).map((priceKey, i) => {
					const priceItem = prices[priceKey];
					const type = !!priceItem.sale_type ? priceItem.sale_type : null;
					const typeText = !!type ? type + ": " : "";
					const total = calculateSalePrice(product.price, priceItem.price, priceItem.price_type);
					return {
						typeText,
						total
					};
				})
			});

			// We need to use the first variant options for the product
			// This will be for "Suggested Products", or a product preview, etc.
			if (this.props.getFirstVariant) {
				variantItemToUse = getFirstVariants(product);
			}

			// Determine if variants exist for product
			const itemIdToCheck = !!variantItemToUse.id ? variantItemToUse.id : null;

			// Get product total
			if (!!variantItemToUse.price) {
				productTotal = productTotal + variantItemToUse.price;
			}

			// If no promotions are set,
			if (isEmpty(promotions) && this.props.mainProduct) {
				this.props.setProductFinalPrice(this.state.productTotal);
				this.setState({
					productTotal
				});
				return;
			}

			// Promotion prices
			Object.keys(promotions).forEach((promoKey, i) => {
				for (let variantId in promotions[promoKey]) {
					// Ensure the variant id is an integer
					variantId = parseInt(variantId, 10);

					// console.log(itemIdToCheck, variantId, promotions[promoKey]);

					// If a variant exists for this product AND this variant isn't the one currently selected by the user.
					// Therefore, skip the promotion for the variant.
					if (!!itemIdToCheck && variantId !== itemIdToCheck) continue;

					// Calculate price
					const promo = promotions[promoKey];
					const sale_total = calculateSalePrice(productTotal, promo[variantId].price, promo[variantId].price_type);

					// console.log(this.state.pricesObj);

					// Set the pricesObj array.
					// This will be the active final price.
					//
					// Note:
					// Commented line was left from when it looked like the price list had multiple variants in it.
					// Not sure why.
					this.setState({
						pricesObj: {
							...this.state.pricesObj,
							// [variantId]: {
							variantSelected: {
								typeText: "Sale",
								total: sale_total
							}
						}
					});

					// If this is the main product, set the final price for the current state of the app
					if (this.props.mainProduct) {
						this.props.setProductFinalPrice(sale_total);
					}

					return;
				}
			});

			this.setState({ productTotal });
		}
	}

	render() {
		const prices_shown = !!this.props.siteInfo.prices_shown ? this.props.siteInfo.prices_shown : 0;
		let element = null;
		if (prices_shown) {

			// Set up list of prices
			element = (
				<div className="prices_container">
					<span className={this.state.topTierOriginalPrice === 0 ? this.state.priceClassName : 'price inactive'}>
						CAN <NumberFormat value={this.state.topTierOriginalPrice === 0 ? this.state.productTotal : this.state.topTierOriginalPrice} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} />
					</span>
					{isEmpty(this.state.pricesObj) && this.state.topTierOriginalPrice !== 0 && 
					<span className="price sale_top_tier">
						{'MEMBER PRICE: '}<span>CAN </span>
						<NumberFormat value={this.state.productTotal} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} />
					</span>
					}
					{Object.keys(this.state.pricesObj).map((id, i) => {
						const { total, typeText } = this.state.pricesObj[id];

						// ===================================
						// 	Left this code behind in case I need it in the future for reference
						// 	At one point the pricesObj would have all prices for all variants.
						//	Not sure why.
						// ===================================
						// console.log(this.props.variantItem.id);
						// if (
						// 	!this.props.getFirstVariant &&
						// 	!!this.props.variantItem &&
						// 	parseInt(id, 10) !== parseInt(this.props.variantItem.id, 10)
						// ) {
						// 	// console.log(id, parseInt(this.props.variantItem.id));
						// 	return null;
						// }

						return (
							<span key={i} className={`price ${this.state.topTierOriginalPrice === 0 ? 'sale' : 'sale_top_tier'}`}>
								{this.state.topTierOriginalPrice === 0 ? typeText : 'MEMBER PRICE: '}{this.state.topTierOriginalPrice !== 0 && <span>CAN </span>}
								<NumberFormat value={total} displayType={"text"} decimalScale={2} fixedDecimalScale={true} thousandSeparator={true} prefix={"$"} />
							</span>
						);
					})}
				</div>
			);
		}

		return element;
	}
}

function mapStateToProps(state) {
	return {
		siteInfo: state.siteInfo,
		variantItem: !!state.productVariant.variant ? state.productVariant.variant : {}
	};
}

export default connect(
	mapStateToProps,
	{ setProductFinalPrice }
)(ProductPriceList);



// WEBPACK FOOTER //
// ./src/components/product/ProductPriceList.js